export enum MessageSenderType {
  Merchant = "merchant",
  Customer = "customer",
  System = "system",
  Ai = "ai",
  AutoReply = "auto_reply",
  ChatFlow = "chat_flow",
}
